import React from "react";

const PackageInclusions = ({ inclusions = [] }) => {
  // Default inclusions if not provided
  const defaultInclusions = [
    {
      icon: "🚌",
      title: "Transport",
    },
    {
      icon: "🍽️",
      title: "Meals",
    },
    {
      icon: "🧭",
      title: "Guide",
    },
    {
      icon: "🩺",
      title: "First Aid",
    },
    {
      icon: "🎟️",
      title: "Entry",
    },
    {
      icon: "🧑‍🏫",
      title: "Instructor",
    },
  ];

  const itemsToDisplay = inclusions.length > 0 ? inclusions : defaultInclusions;

  // Take only first 6 items for display
  const displayItems = itemsToDisplay.slice(0, 6);

  return (
    <div className="bg-white shadow-md rounded-lg p-4 sm:p-6 mb-6">
      <h2 className="text-xl sm:text-2xl font-bold text-gray-800 mb-5 sm:mb-6">
        What's Included
      </h2>

      {/* Grid Layout - 3 columns on mobile, 3 on tablet, 6 on desktop */}
      <div className="grid grid-cols-3 lg:grid-cols-6 gap-2 sm:gap-3">
        {displayItems.map((item, index) => (
          <div
            key={index}
            className="flex flex-col items-center justify-center p-3 sm:p-4 bg-gradient-to-br from-indigo-50 to-indigo-100 rounded-lg border-2 border-indigo-300 hover:border-indigo-400 hover:shadow-md transition"
          >
            <div className="text-3xl sm:text-4xl mb-2 flex items-center justify-center h-10 w-full">
              {item.icon}
            </div>
            <h3 className="text-xs sm:text-sm font-bold text-gray-800 text-center">
              {item.title}
            </h3>
          </div>
        ))}
      </div>

      {/* Info Box */}
      <div className="mt-5 sm:mt-6 p-3 sm:p-4 bg-blue-50 rounded-lg border-2 border-blue-200">
        <p className="text-xs sm:text-sm text-blue-900 text-center">
          <strong>All essentials covered!</strong> More details in Inclusion
          section.
        </p>
      </div>
    </div>
  );
};

export default PackageInclusions;
